const FilterFields = [
  {
    name: "companyId",
    label: "Company Name",
    disabled: true,
    select: true,
  },
  {
    name: "siteId",
    label: "Site Name",
    select: true,
    disabled: true,
    required: true,
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "fromDate",
    label: "From",
    validationType: "string",
    date: true,
  },
  {
    name: "toDate",
    label: "To",
    validationType: "string",
    date: true,
  },
];
const FormFields = [
  {
    name: "siteId",
    label: "Site Name",
    select: true,
    disabled: true,
    validationType: "number",
  },
  {
    label: "Title",
    name: "title",
    textField: true,
    type: "text",
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Number Of People",
    name: "number",
    textField: true,
    type: "number",
    required: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "startDate",
    label: "From",
    required: true,
    validationType: "string",
    date: true,
  },
  {
    name: "endDate",
    label: "To",

    validationType: "string",
    date: true,
  },
];
export { FilterFields, FormFields };
